import { FC, KeyboardEventHandler, MouseEventHandler } from 'react'
import Svg from '@/public/images/common/chevron-down_v2.svg'
import { TextTag2 } from '@components-v2/atoms/TextTag2'
import styles from './index.module.scss'

type Props = {
  placeholder?: string
  onClick: MouseEventHandler<HTMLDivElement>
  onKeyPress: KeyboardEventHandler<HTMLDivElement>
  selectedItems?: { id: string; name: string }[]
  onDeleteSelectedItem?: (id: string) => void
  onDeletedAllSelectedItems?: () => void
  isMultiple?: boolean
}

// 選択済みのタグの最大数
const MAX_TAG_COUNT = 1

/**
 * 実際の select タグではなく、select フィールドのUI用のコンポーネント
 */
export const SelectMenuTrigger: FC<Props> = ({
  placeholder = '',
  onClick,
  onKeyPress,
  selectedItems = [],
  onDeleteSelectedItem = () => {},
  onDeletedAllSelectedItems = () => {},
  isMultiple = true,
}) => {
  type TagType = 'none' | 'single' | 'muli-all' | 'muli-limited'
  let tagType: TagType = 'none'

  if (selectedItems.length === 0) {
    tagType = 'none'
  } else if (!isMultiple) {
    tagType = 'single'
  } else if (selectedItems.length <= MAX_TAG_COUNT) {
    tagType = 'muli-all'
  } else {
    tagType = 'muli-limited'
  }

  return (
    <div role='button' tabIndex={0} onClick={onClick} onKeyPress={onKeyPress} className={styles.container}>
      <div className={styles.left}>
        {tagType === 'none' && <div className={styles.placeholder}>{placeholder}</div>}
        {tagType === 'single' && (
          <div className={styles.tags}>
            <TextTag2 size='md'>{selectedItems[0].name}</TextTag2>
          </div>
        )}
        {tagType === 'muli-all' && (
          <div className={styles.tags}>
            {selectedItems.map((item) => (
              <TextTag2 size='md' withDelete onDelete={() => onDeleteSelectedItem(item.id)} key={item.id}>
                {item.name}
              </TextTag2>
            ))}
          </div>
        )}
        {tagType === 'muli-limited' && (
          <div className={styles.tags}>
            <TextTag2
              size='md'
              withDelete
              onDelete={onDeletedAllSelectedItems}
            >{`${placeholder} (${selectedItems.length})`}</TextTag2>
          </div>
        )}
      </div>

      <div className={styles.right}>
        <Svg viewBox='0 0 24 24' />
      </div>
    </div>
  )
}
